module.exports = __webpack_public_path__ + "static/media/2.71c437c8.svg";